module.exports = __webpack_public_path__ + "img/Live Data Icon_Over.ad58c546.svg";